import React, { useState, useEffect } from "react";

type CardProps = {
    title: React.ReactNode;
    description: string;
    Icon: React.ReactNode;
};

const Card: React.FC<CardProps> = ({
                                       title,
                                       description,
                                       Icon,
                                      
                                   }) => {
    const [animate, setAnimate] = useState(true);

    // Stop animation after 3 seconds
    const ANIMATION_DURATION_MS = 3000;

    useEffect(() => {
        setTimeout(() => setAnimate(false), ANIMATION_DURATION_MS);
    }, []);

    return (
        <div className="relative group rounded-xl">
            {/* Rotating multi-color border */}
            <div
                className={`absolute -inset-1 rounded-xl border-2 md:border-4 border-transparent bg-gradient-to-r from-orange-500 via-blue-500 to-gray-400 pointer-events-none z-0
          ${animate ? "animate-spin opacity-20" : "opacity-20"}
          group-hover:animate-spin group-hover:opacity-100`}
            ></div>

            {/* Card content */}
            <div className="bg-white rounded-xl p-5 md:p-6 shadow hover:shadow-lg relative z-10 flex flex-col items-center text-center">
                {Icon}
                <h3 className="text-base md:text-lg font-semibold text-blue-900 mb-2">{title}</h3>
                <p className="text-gray-600 text-sm">{description}</p>
            </div>
        </div>
    );
};

export default Card;


